import { useQuery } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';
// Non-null assertion (!) explicitly used to solve type problems. This just works together with the 'enabled' option.
// id can be undefined, due to the usage in CreateEnquiryFlow
export const useOrder = (id?: string) => {
    return useQuery({ ...queries.orders.detail(id!), enabled: !!id });
};
